import React from 'react';

const DateNights = ({ nights, onChange, daysInterval }) => {
  return (
    <div className="dates-filter-nights__list">
      {nights.map(({ value, isSelected }) => (
        <div
          key={value}
          className={`dates-filter-nights__item ${isSelected ? 'selected' : ''} ${
            daysInterval && daysInterval < value ? 'not-active-night' : ''
          }`}
          onClick={daysInterval && daysInterval >= value && onChange(value)}
        >
          {value}
        </div>
      ))}
    </div>
  );
};

export default DateNights;
